/*
 * iurop-workshops — Página de Talleres Kawaicafe.
 *   · Galería: track deslizante con flechas (bucle), puntos y miniaturas.
 *   · Calendario: vista de mes en español (lunes primero), navegación con
 *     límites, estados disponible / no disponible / hoy / seleccionado.
 *     Fechas por taller (data-w-dates): lista ISO "2026-08-02, 2026-08-09",
 *     patrones semanales "sabados" / "domingos" / "viernes" y "diario" (o
 *     "todos") = todos los días desde hoy. Todo mezclable.
 *   · Reserva: al elegir día se activan los CTA (principal + aside) y se
 *     construye la URL (wa.me / mailto / URL normal) con taller, fecha y local.
 *   Sin dependencias.
 */
(function () {
  'use strict';

  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var DIAS_SEMANA = { lunes: 1, martes: 2, miercoles: 3, jueves: 4, viernes: 5, sabado: 6, sabados: 6, domingo: 0, domingos: 0 };

  function stripAccents(str) {
    return str.normalize ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : str;
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function isoOf(date) {
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
  }

  // "sabados, 2026-08-15" → { exact: Set<iso>, weekdays: Set<0-6> }
  function parseDates(str) {
    var exact = {};
    var weekdays = {};
    var any = false;
    (str || '').split(/[,;\n]+/).forEach(function (raw) {
      var tok = raw.trim();
      if (!tok) return;
      if (/^\d{4}-\d{2}-\d{2}$/.test(tok)) {
        exact[tok] = true;
        any = true;
        return;
      }
      var key = stripAccents(tok.toLowerCase()).replace(/^los\s+/, '');
      // "diario" / "todos (los dias)" → abre todos los días de la semana.
      if (/^(diario|diaria|todos?(\s+los\s+dias)?|todas)$/.test(key)) {
        for (var wd = 0; wd < 7; wd++) weekdays[wd] = true;
        any = true;
        return;
      }
      if (key in DIAS_SEMANA) {
        weekdays[DIAS_SEMANA[key]] = true;
        any = true;
      }
    });
    return { exact: exact, weekdays: weekdays, any: any, hasPattern: Object.keys(weekdays).length > 0 };
  }

  // ---- Galería ---------------------------------------------------------------
  // Mismo comportamiento que la galería de la PDP (QA talleres): flechas en
  // bucle, puntos, miniaturas, ARRASTRE/SWIPE y centrado de la miniatura activa
  // en la tira cuando no caben todas. Devuelve el controlador para que el
  // lightbox abra por la imagen que se está viendo y sincronice al cerrar.
  function initGallery(root) {
    var track = root.querySelector('[data-w-track]');
    if (!track) return null;
    var n = track.children.length;
    var dots = root.querySelectorAll('[data-w-dots] .kawaii-wshop__dot');
    var thumbs = root.querySelectorAll('[data-w-thumbs] .kawaii-wshop__thumb');
    var thumbsWrap = root.querySelector('[data-w-thumbs]');
    var active = 0;

    // Deja la miniatura activa a la vista (la tira scrollea cuando no caben).
    function centerActiveThumb() {
      if (!thumbsWrap) return;
      var el = thumbs[active];
      if (!el) return;
      var max = thumbsWrap.scrollWidth - thumbsWrap.clientWidth;
      if (max <= 2) return;
      var target = el.offsetLeft - (thumbsWrap.clientWidth - el.offsetWidth) / 2;
      target = Math.max(0, Math.min(target, max));
      // En pestaña oculta las animaciones de scroll no corren → salto directo.
      thumbsWrap.scrollTo({ left: target, behavior: document.hidden ? 'auto' : 'smooth' });
    }

    function render() {
      track.style.transform = 'translateX(' + (-100 * active) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === active); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === active); });
      centerActiveThumb();
    }
    function go(i) {
      active = ((i % n) + n) % n;
      render();
    }

    var api = { go: go, index: function () { return active; } };
    if (n < 2) { render(); return api; }

    var prev = root.querySelector('[data-w-prev]');
    var next = root.querySelector('[data-w-next]');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    // Swipe táctil + arrastre con ratón. El umbral de 40px evita que un toque
    // para abrir el lightbox se lea como gesto.
    var x0 = null, y0 = null, drag = false;
    track.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      // Solo si el gesto es claramente horizontal: si no, es scroll de página.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(active + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      drag = true; x0 = e.clientX;
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return;
      drag = false;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 60) go(active + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    // Teclado: flechas cuando el foco está dentro de la galería.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(active - 1); }
      else if (e.key === 'ArrowRight') { go(active + 1); }
    });

    render();
    return api;
  }


  // ---- Lightbox de la galeria -------------------------------------------------
  // Al pulsar una foto se abre a pantalla completa (mismo componente que la PDP).
  function initLightbox(gal, ctrl) {
    if (!gal || gal.dataset.wLb) return;
    var track = gal.querySelector('[data-w-track]');
    if (!track) return;
    var imgs = [].slice.call(track.querySelectorAll('img'));
    if (!imgs.length) return;
    gal.dataset.wLb = '1';

    var urls = imgs.map(function (i) { return i.getAttribute('data-w-full') || i.currentSrc || i.src; });
    var alts = imgs.map(function (i) { return i.getAttribute('alt') || ''; });
    var n = urls.length;

    var lb = document.createElement('div');
    lb.className = 'kawaii-lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<div class="kawaii-lightbox__backdrop" data-lb-close></div>' +
      '<figure class="kawaii-lightbox__stage"><img class="kawaii-lightbox__img" alt=""></figure>' +
      '<button class="kawaii-lightbox__close" type="button" data-lb-close aria-label="Cerrar">&times;</button>' +
      (n > 1 ? '<button class="kawaii-lightbox__nav kawaii-lightbox__nav--prev" type="button" data-lb-prev aria-label="Anterior">&#8249;</button>' +
        '<button class="kawaii-lightbox__nav kawaii-lightbox__nav--next" type="button" data-lb-next aria-label="Siguiente">&#8250;</button>' +
        '<div class="kawaii-lightbox__count" data-lb-count></div>' : '');
    document.body.appendChild(lb);

    var img = lb.querySelector('.kawaii-lightbox__img');
    var counter = lb.querySelector('[data-lb-count]');
    var idx = 0;
    var cache = {};
    function preload(i) {
      var k = ((i % n) + n) % n;
      if (cache[k]) return;
      var im = new Image(); im.decoding = 'async'; im.src = urls[k]; cache[k] = im;
    }
    function show(i) {
      idx = ((i % n) + n) % n;
      img.src = urls[idx];
      img.alt = alts[idx];
      if (counter) counter.textContent = (idx + 1) + ' / ' + n;
      preload(idx + 1); preload(idx - 1);
    }
    function open(i) {
      show(i);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('kp-lb-open');
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('kp-lb-open');
      // Al cerrar, la galería se queda en la última foto vista (como la PDP).
      if (ctrl) ctrl.go(idx);
    }
    imgs.forEach(function (im, i) {
      im.style.cursor = 'zoom-in';
      // Se abre por la imagen que se está VIENDO: con el track desplazado, el
      // índice del nodo no es el de la diapositiva visible.
      im.addEventListener('click', function () { open(ctrl ? ctrl.index() : i); });
    });
    // Gesto lateral dentro del lightbox.
    var lx = null;
    lb.addEventListener('touchstart', function (e) { lx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (lx === null) return;
      var d = e.changedTouches[0].clientX - lx;
      if (Math.abs(d) > 40) show(idx + (d < 0 ? 1 : -1));
      lx = null;
    }, { passive: true });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]')) close();
      else if (e.target.closest('[data-lb-prev]')) show(idx - 1);
      else if (e.target.closest('[data-lb-next]')) show(idx + 1);
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  // ---- Calendario + reserva ---------------------------------------------------
  function initTaller(taller) {
    var cal = taller.querySelector('[data-w-cal]');
    var grid = taller.querySelector('[data-w-cal-grid]');
    var monthEl = taller.querySelector('[data-w-cal-month]');
    var prevBtn = taller.querySelector('[data-w-cal-prev]');
    var nextBtn = taller.querySelector('[data-w-cal-next]');
    var localSel = taller.querySelector('[data-w-local]');

    var nombre = taller.getAttribute('data-w-nombre') || 'Taller';
    var baseUrl = (taller.getAttribute('data-w-url') || '').trim();
    var dates = parseDates(taller.getAttribute('data-w-dates'));
    var closedDates = parseDates(taller.getAttribute('data-w-closed'));

    var hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    var hoyIso = isoOf(hoy);

    // Cada taller manda: fechas ISO y/o patrones semanales configurados en su
    // metaobjeto. Los meses pasados nunca son navegables.
    var TODOS_LOS_DIAS = false;
    function disponible(date) {
      if (date < hoy) return false;
      if (date.getDay() === 0 || date.getDay() === 6) return false;
      if (closedDates.exact[isoOf(date)]) return false;
      if (TODOS_LOS_DIAS) return true;
      var iso = isoOf(date);
      if (dates.exact[iso]) return true;
      return !!dates.weekdays[date.getDay()];
    }

    // Límites de navegación: del mes actual al último mes con fechas
    // (o +11 meses si hay patrón semanal recurrente).
    var minView = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    var maxView = new Date(minView);
    if (dates.hasPattern) {
      maxView = new Date(hoy.getFullYear(), hoy.getMonth() + 11, 1);
    }
    Object.keys(dates.exact).forEach(function (iso) {
      var d = new Date(iso + 'T12:00:00');
      var m = new Date(d.getFullYear(), d.getMonth(), 1);
      if (m > maxView) maxView = m;
    });

    // Vista inicial: primer mes con algún día disponible.
    var view = new Date(minView);
    (function () {
      var probe = new Date(minView);
      for (var i = 0; i <= 12; i++) {
        var dias = new Date(probe.getFullYear(), probe.getMonth() + 1, 0).getDate();
        for (var d = 1; d <= dias; d++) {
          if (disponible(new Date(probe.getFullYear(), probe.getMonth(), d))) {
            view = new Date(probe);
            return;
          }
        }
        probe.setMonth(probe.getMonth() + 1);
        if (probe > maxView) break;
      }
    })();

    var sel = null; // iso seleccionada
    var selHora = null; // hora elegida (obligatoria si el taller tiene horas)
    var ctas = []; // { el, textEl, base }

    // ---- Horas (pop-up al elegir dia) --------------------------------------
    var hpop = taller.querySelector('[data-w-hpop]');
    var horasList = taller.querySelector('[data-w-hours-list]');
    var pick = taller.querySelector('[data-w-pick]');
    var pickTxt = taller.querySelector('[data-w-pick-txt]');
    var pickEdit = taller.querySelector('[data-w-pick-edit]');
    var hpopDay = taller.querySelector('[data-w-hpop-day]');
    var horas = (taller.getAttribute('data-w-horas') || '')
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);
    var pideHora = !!(hpop && horasList && horas.length);
    // Un `position: fixed` deja de ser relativo al viewport si CUALQUIER ancestro
    // tiene transform/filter/will-change (las animaciones de la pagina los ponen
    // y los quitan), y entonces el pop-up sale descolocado. Vive en el <body>.
    if (hpop && hpop.parentNode !== document.body) document.body.appendChild(hpop);

    function fechaLarga(iso) {
      if (!iso) return '';
      var d = new Date(iso + 'T12:00:00');
      return d.toLocaleDateString(document.documentElement.lang || 'es-ES', {
        weekday: 'long', day: 'numeric', month: 'long'
      });
    }
    function abrirHoras() {
      if (!pideHora || !sel) return;
      if (hpopDay) hpopDay.textContent = fechaLarga(sel);
      hpop.hidden = false;
      document.documentElement.setAttribute('data-modal-open', 'true');
      var primero = horasList.querySelector('.kawaii-wshop__hour');
      if (primero) primero.focus();
    }
    function cerrarHoras() {
      if (!pideHora) return;
      hpop.hidden = true;
      document.documentElement.removeAttribute('data-modal-open');
    }
    function pintarHoras() {
      if (!pideHora) return;
      horasList.innerHTML = '';
      horas.forEach(function (h) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kawaii-wshop__hour' + (h === selHora ? ' is-on' : '');
        b.textContent = h;
        b.setAttribute('aria-pressed', h === selHora ? 'true' : 'false');
        b.addEventListener('click', function () {
          selHora = h;
          pintarHoras();
          cerrarHoras();
          updateCtas();
        });
        horasList.appendChild(b);
      });
      if (pick) {
        var hay = !!sel;
        pick.hidden = !hay;
        if (pickTxt) pickTxt.textContent = hay ? (fechaLarga(sel) + (selHora ? ' · ' + selHora : '')) : '';
      }
    }
    if (pideHora) {
      hpop.addEventListener('click', function (e) {
        if (e.target.closest('[data-w-hpop-close]')) cerrarHoras();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !hpop.hidden) cerrarHoras();
      });
      if (pickEdit) pickEdit.addEventListener('click', abrirHoras);
    }

    // Email de reservas del local elegido (data-email de la opción) o el del taller.
    function reserveEmail() {
      var opt = localSel && localSel.options[localSel.selectedIndex];
      return (opt && opt.getAttribute('data-email')) || taller.getAttribute('data-w-email') || '';
    }

    function buildUrl() {
      if (!sel) return null;
      var fecha = new Date(sel + 'T12:00:00');
      var lang = document.documentElement.lang || 'es-ES';
      var fechaTxt = fecha.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      var local = localSel && localSel.value ? localSel.value : '';
      var horaTxt = selHora ? ' a las ' + selHora : '';
      var msg = '¡Hola! Quiero reservar el taller "' + nombre + '" el ' + fechaTxt + horaTxt + (local ? ' en ' + local : '') + '.';
      var url = baseUrl;

      if (url) {
        if (/^(wa\.me|api\.whatsapp\.com)/i.test(url)) url = 'https://' + url;
        if (/^https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)/i.test(url) || /^whatsapp:/i.test(url)) {
          return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'text=' + encodeURIComponent(msg);
        }
        if (/^mailto:/i.test(url)) {
          return url + (url.indexOf('?') >= 0 ? '&' : '?') +
            'subject=' + encodeURIComponent('Reserva: ' + nombre) +
            '&body=' + encodeURIComponent(msg);
        }
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'fecha=' + encodeURIComponent(sel) +
          (selHora ? '&hora=' + encodeURIComponent(selHora) : '');
      }

      // Sin enlace propio: email al local con el taller y la fecha ya rellenados.
      var email = reserveEmail();
      if (!email) return null;
      var body = msg + '\n\nNombre:\nNº de personas:\nTeléfono:\n\n¡Gracias!';
      return 'mailto:' + email + '?subject=' + encodeURIComponent('Reserva taller – ' + (local || nombre)) + '&body=' + encodeURIComponent(body);
    }

    function updateCtas() {
      // Con horas configuradas hace falta fecha Y hora para poder reservar.
      var on = !!sel && (!pideHora || !!selHora);
      var href = on ? buildUrl() : null;
      var corta = on
        ? new Date(sel + 'T12:00:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }) +
          (selHora ? ' · ' + selHora : '')
        : '';
      ctas.forEach(function (c) {
        c.el.classList.toggle('is-disabled', !on);
        c.el.setAttribute('aria-disabled', on ? 'false' : 'true');
        if (c.main) c.el.setAttribute('tabindex', '0'); // siempre alcanzable: guia al usuario
        if (on && href) {
          c.el.setAttribute('href', href);
          if (/^https?:/i.test(href)) {
            c.el.setAttribute('target', '_blank');
            c.el.setAttribute('rel', 'noopener');
          } else {
            c.el.removeAttribute('target');
            c.el.removeAttribute('rel');
          }
        } else {
          c.el.removeAttribute('href');
          c.el.removeAttribute('target');
          c.el.removeAttribute('rel');
        }
        if (c.textEl) c.textEl.textContent = on ? c.base + ' · ' + corta : c.base;
        if (c.noteEl) c.noteEl.hidden = on;
      });
    }

    function render() {
      if (!grid || !monthEl) return;
      monthEl.textContent = MESES[view.getMonth()] + ' ' + view.getFullYear();
      if (prevBtn) prevBtn.disabled = view <= minView;
      if (nextBtn) nextBtn.disabled = view >= maxView;

      var y = view.getFullYear();
      var m = view.getMonth();
      var dias = new Date(y, m + 1, 0).getDate();
      var offset = (new Date(y, m, 1).getDay() + 6) % 7; // lunes primero

      var html = '';
      var i;
      for (i = 0; i < offset; i++) {
        html += '<span class="kawaii-wshop__day is-empty" aria-hidden="true"></span>';
      }
      for (var d = 1; d <= dias; d++) {
        var date = new Date(y, m, d);
        var iso = isoOf(date);
        var av = disponible(date);
        var cls = 'kawaii-wshop__day';
        if (av) cls += ' is-av';
        if (iso === hoyIso) cls += ' is-today';
        if (iso === sel) cls += ' is-sel';
        var label = date.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
        html += '<button type="button" class="' + cls + '" data-w-day="' + iso + '"' +
          (av ? '' : ' disabled') +
          ' aria-label="' + label + (av ? ', disponible' : ', no disponible') + '"' +
          ' aria-pressed="' + (iso === sel ? 'true' : 'false') + '"' +
          '>' + d + '</button>';
      }
      grid.innerHTML = html;
    }

    if (grid) {
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-w-day]');
        if (!btn || btn.disabled) return;
        var iso = btn.getAttribute('data-w-day');
        sel = sel === iso ? null : iso; // volver a pulsar deselecciona
        if (!sel) selHora = null;        // sin fecha no hay hora
        else selHora = null;             // dia nuevo -> se vuelve a pedir la hora
        render();
        pintarHoras();
        updateCtas();
        if (sel) abrirHoras();
      });
    }
    // El email/mensaje depende del local elegido → recalcular el CTA al cambiarlo.
    if (localSel) localSel.addEventListener('change', updateCtas);
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
        render();
      });
    }
    if (localSel) localSel.addEventListener('change', updateCtas);

    // CTA principal del taller.
    var mainCta = taller.querySelector('[data-w-cta]');
    if (mainCta) {
      ctas.push({
        el: mainCta,
        textEl: mainCta.querySelector('[data-w-cta-text]'),
        base: mainCta.getAttribute('data-w-cta-base') || 'Reservar',
        main: true
      });
      mainCta.addEventListener('click', function (e) {
        // El boton SIEMPRE responde (QA talleres: "el cta de reservar esta
        // bloqueado, puedes abrirlo"): si falta el dia lleva al calendario y si
        // falta la hora abre el pop-up, en vez de no hacer nada.
        if (!mainCta.getAttribute('href')) {
          e.preventDefault();
          if (!sel) {
            if (cal) cal.scrollIntoView({ behavior: document.hidden ? 'auto' : 'smooth', block: 'center' });
          } else {
            abrirHoras();
          }
          return;
        }
      });
    }

    render();
    pintarHoras();
    updateCtas();

    return {
      // registra un CTA externo (el del aside) sincronizado con este taller.
      addCta: function (el, noteEl) {
        ctas.push({ el: el, textEl: el.querySelector('span'), base: (el.textContent || 'Reservar').trim(), noteEl: noteEl });
        el.addEventListener('click', function (e) {
          if (!el.getAttribute('href')) {
            e.preventDefault();
            // El CTA del aside SIEMPRE sube al calendario. Antes, con la fecha ya
            // elegida, abria el pop-up de horas desde el pie de la pagina: el
            // cliente lo veia "aparecer en otro sitio", lejos del calendario
            // (QA talleres). La eleccion de hora vive junto al calendario.
            if (cal) {
              cal.scrollIntoView({ behavior: 'smooth', block: 'center' });
              cal.classList.remove('is-pulse');
              void cal.offsetWidth; // reinicia la animación
              cal.classList.add('is-pulse');
              setTimeout(function () { cal.classList.remove('is-pulse'); }, 2000);
            }
          }
        });
        updateCtas();
      }
    };
  }

  // ---- Init por sección --------------------------------------------------------
  function initSection(section) {
    if (section.dataset.kwInit) return;
    section.dataset.kwInit = '1';

    var controllers = [];
    section.querySelectorAll('[data-w-taller]').forEach(function (taller) {
      var gal = initGallery(taller);
      initLightbox(taller.querySelector('[data-w-gallery]'), gal);
      var ctrl = initTaller(taller);
      if (ctrl) controllers.push(ctrl);
    });

    // El aside espeja el primer taller.
    var asideCta = section.querySelector('[data-w-aside-cta]');
    if (asideCta && controllers.length) {
      controllers[0].addCta(asideCta, section.querySelector('[data-w-aside-note]'));
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.kawaii-wshop').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
